/**
 * A module containing utilities for parsing the query string.
 * @module abt-utils/query-string
 */

import _ from 'lodash'

/**
 * Gets a query string parameter value.
 * @param {string} parameter - The parameter name to get.
 * @returns {object|string} Return the specified parameter value or an object representing the
 * query string parameters & values.
 */
export function get (parameter, queryString) {
  var queryStringData = parse(queryString)
  return parameter ? queryStringData[parameter] : queryStringData
}

/**
 * Parses the query string into an object.
 * @param {string} queryString - The query string to parse.
 * @returns {object} Retrusn an object representing the query string parameters & values.
 */
export function parse (queryString) {
  queryString = queryString || window.location.search
  var parameters = _format(queryString).split('&')
  return _.fromPairs(_.map(parameters, _decode))
}

/**
 * Decodes the parameter string and returns key/value pair to use with _.fromPairs.
 * @param {string} parameter - The parameter to decode.
 * @returns {array} Returns the decoded parameter ready for _.fromPairs.
 */
export function _decode (parameter) {
  var key = window.decodeURIComponent(_.first(parameter.split('=')))
  var value = window.decodeURIComponent(_.last(parameter.split('=')))
  return [key, value]
}

/**
 * Formats query string data before parsing.
 * @param {string} queryString - The query string to format.
 * @returns {string} Returns the formatted query string data.
 */
export function _format (queryString) {
  return queryString.indexOf('?') === 0 ? queryString.substr(1) : queryString
}



/*****************
 ** WEBPACK FOOTER
 ** ./src/abt-utils/query-string.js
 ** module id = 6
 ** module chunks = 2 3
 **/